import { EventBus } from '@/utils/event-bus.js';

export default {
    methods: {
        
        addGlobalEventListeners() {
        if (process.client) {
            // Your code that uses `document`...
             const triggers = document.querySelectorAll('.contact-form-trigger');
             const leadForm = document.querySelector('.lead-form');
             triggers.forEach(trigger => {
             trigger.addEventListener('click', (e) => {
                 e && e.preventDefault && e.preventDefault();
                 if (leadForm) {
                   leadForm.scrollIntoView({ behavior: 'smooth', block: 'start' });
                 } else {
                   EventBus.$emit('open-modal');
                 }
                   });
             });
        
        }
            
        
            
        },

    }
  }